<template>
  <section-box :class="['integration', {'is-integrated': isIntegrated}]">
    <div
      v-if="isIntegrated"
      class="integration--status"
    >
      <icon-default icon="check"/>
    </div>

    <p v-if="type" class="integration--type">{{ type }}</p>

    <div class="integration--header">
      <img
        v-if="integration.iconPath"
        class="integration--header--logo"
        :src="integration.iconPath"
        :alt="heading"
      />
      <h2 class="integration--header--heading">{{ heading }}</h2>
    </div>

    <div class="integration--main">
      <div class="integration--main--description">
        <slot></slot>
      </div>

      <div class="integration--main--actions">
        <button-outlined @click="goToIntegrationsPage">{{ isIntegrated ? 'Manage' : 'Start' }} {{ integration.label }} Integration</button-outlined>
      </div>
    </div>
  </section-box>
</template>

<script>
export default {
  name: "IntegrationBox",
  props: {
    heading: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    integration: {
      type: Object,
      required: true,
    },
    isIntegrated: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    goToIntegrationsPage() {
      this.$router.push({name: "settings", params: {'tab': 'integrations', 'page': this.integration.url}})
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.integration {
  position: relative;
  margin-bottom: 20px;
  padding-right: 40px;
  border: 2px solid $white;

  &.is-integrated {
    border-color: $secondary;
  }
}

.integration--status {
  position: absolute;
  top: 0;
  right: 0;
  height: 30px;
  width: 30px;
  padding-top: 4px;
  padding-left: 2px;
  background-color: $secondary;
  color: $white;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 100%;
    width: 0;
    height: 0;
    border-left: 30px solid transparent;
    border-top: 30px solid $secondary;
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 0;
    height: 0;
    border-left: 30px solid transparent;
    border-top: 30px solid $secondary;
  }
}

.integration--type {
  margin-bottom: 6px;
  font-size: 0.875rem;
  color: $text-muted;
}

.integration--header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  &--logo {
    height: 18px;
    margin-right: 8px;
  }

  &--heading {
    font-size: 20px;
    font-weight: bold;
    color: $primary;
  }
}

.integration--main {

  &--description {
    line-height: 1.3;
  }

  &--actions {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
  }
}
</style>
